/**
 * Session Storage Utilities - Core SDK (Framework-agnostic)
 * Handles session persistence using browser cookies
 */

const FUNNEL_SESSION_COOKIE_NAME = 'tgd-funnel-session-id';
const STICKY_SESSION_COOKIE_NAME = 'tgd-session-id';
const SESSION_MAX_AGE = 30 * 24 * 60 * 60; // 30 days

/**
 * Save funnel session ID to browser cookie
 */
export function setFunnelSessionCookie(sessionId: string): void {
  if (typeof document === 'undefined') return;

  document.cookie = `${FUNNEL_SESSION_COOKIE_NAME}=${sessionId}; path=/; max-age=${SESSION_MAX_AGE}; SameSite=Lax`;
}

/**
 * Retrieve funnel session ID from browser cookie
 */
export function getFunnelSessionCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${FUNNEL_SESSION_COOKIE_NAME}=`));

  return cookie ? cookie.split('=')[1] : undefined;
}

/**
 * Clear funnel session cookie
 */
export function clearFunnelSessionCookie(): void {
  if (typeof document === 'undefined') return;

  document.cookie = `${FUNNEL_SESSION_COOKIE_NAME}=; path=/; max-age=0`;
}

/**
 * Check if a funnel session cookie exists
 */
export function hasFunnelSessionCookie(): boolean {
  return !!getFunnelSessionCookie();
}

/**
 * Retrieve funnel variant ID from sticky session (for A/B tracking)
 * The variant ID is stored in the sticky session metadata by plugin-routing
 */
export function getFunnelVariantId(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  try {
    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${STICKY_SESSION_COOKIE_NAME}=`));

    if (!cookie) return undefined;

    const sessionData = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
    return sessionData?.metadata?.funnelVariantId;
  } catch (error) {
    console.warn('Failed to parse sticky session for variant ID:', error);
    return undefined;
  }
}


